import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss', './../ifacss.scss']
})
export class ReviewComponent implements OnInit {
  Hearclientsaypara1: any;
  Hearclientsaypara2: any;
  Hearclientsaypara3: any;
  Hearclientsaypara4: any;
  InvestorDiscription1: any;
  InvestorDiscription2: any;
  InvestorDiscription3: any;
  InvestorDiscription4: any;
  InvestorDiscription5: any;
  Investorname1: any;
  Investorname2: any;
  Investorname3: any;
  Investorname4: any;
  Investorname5: any;
  Hearclientsaypara5: string;
  Investorimg1: any;
  Investorimg2: any;
  Investorimg3: any;
  Investorimg4: any;
  Investorimg5: any;
  constructor(public sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    debugger;
    this.Hearclientsaypara1 = sessionStorage.getItem('ihjt45h45=f');
    this.Hearclientsaypara2 = sessionStorage.getItem('ihjt45h45=g');
    this.Hearclientsaypara3 = sessionStorage.getItem('ihjt45h45=h');
    this.Hearclientsaypara4 = sessionStorage.getItem('ihjt45h45=v');
    this.Hearclientsaypara5 = sessionStorage.getItem('ihjt45h45=v1');
    this.Investorname1 = sessionStorage.getItem('ihjt45h45=r');
    this.Investorname2 = sessionStorage.getItem('ihjt45h45=r1');
    this.Investorname3 = sessionStorage.getItem('ihjt45h45=r2');
    this.Investorname4 = sessionStorage.getItem('ihjt45h45=r3');
    this.Investorname5 = sessionStorage.getItem('ihjt45h45=r4');
    this.InvestorDiscription1 = sessionStorage.getItem('ihjt45h45=s');
    this.InvestorDiscription2 = sessionStorage.getItem('ihjt45h45=s1');
    this.InvestorDiscription3 = sessionStorage.getItem('ihjt45h45=s2');
    this.InvestorDiscription4 = sessionStorage.getItem('ihjt45h45=s3');
    this.InvestorDiscription5 = sessionStorage.getItem('ihjt45h45=s4');
    setTimeout(() => {
      this.Investorimg1 = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==1')
      );
      this.Investorimg2 = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==2')
      );
      this.Investorimg3 = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==3')
      );
      this.Investorimg4 = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==4')
      );
      this.Investorimg5 = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==5')
      );
    }, 1000);
  }
}
